// extracted by mini-css-extract-plugin
export default {"item":"DropzoneWithProgress_item__HANTd","dragging":"DropzoneWithProgress_dragging__tfhEQ","wrapper":"DropzoneWithProgress_wrapper__2qnS7"};